import styled from 'styled-components';

const LanguageSwitcherStyle = styled.div`
	--selectedLangArrowDistance: var(--sp1x);

	position: relative;
	z-index: 11;
	cursor: pointer;

	.selected-lang-wrap {
		position: relative;
		display: flex;
		align-items: center;
		gap: var(--selectedLangArrowDistance);
		z-index: 3;
		background-color: transparent;
	}

	.languages-wrapper {
		overflow: hidden;
		position: absolute;
		left: 0;
		pointer-events: none;
	}

	.languages-inner-wrapper {
		transform: translateY(-100%);
		transition: transform var(--trTime) ease-out;
	}

	.selected-lang-icon {
		transition: transform var(--trTime) ease-out;
	}

	&.opened {
		.selected-lang-icon {
			transform: rotate(180deg);
		}

		.languages-wrapper {
			pointer-events: all;
		}

		.languages-inner-wrapper {
			transform: translateY(0);
		}

		.lang-item-block {
			margin-top: var(--sp1x);
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default LanguageSwitcherStyle;
